import type { Types } from '@fiverr-private/theme';

export type DotIndicatorSize = 'sm' | 'md' | 'lg';

export type DotIndicatorPosition = 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';

export const TYPES = {
    NEUTRAL: 'neutral',
    INFO: 'info',
    SUCCESS: 'success',
    ERROR: 'error',
    SPECIAL: 'special',
    WARNING: 'warning',
} as const;

export const INDICATOR_SIZES_MAP: Record<DotIndicatorSize, number> = {
    sm: 6,
    md: 8,
    lg: 10,
};

export const PROPS_BY_SIZE: Record<DotIndicatorSize, Pick<Types.BoxType, 'width' | 'height'>> = {
    sm: {
        width: `${INDICATOR_SIZES_MAP.sm}px`,
        height: `${INDICATOR_SIZES_MAP.sm}px`,
    },
    md: {
        width: `${INDICATOR_SIZES_MAP.md}px`,
        height: `${INDICATOR_SIZES_MAP.md}px`,
    },
    lg: {
        width: `${INDICATOR_SIZES_MAP.lg}px`,
        height: `${INDICATOR_SIZES_MAP.lg}px`,
    },
} as const;

export const getPropsByPosition = (
    offset: number,
    position: DotIndicatorPosition,
    borderWidth: Extract<Types.BoxType['borderWidth'], 'sm' | 'md'>
): Pick<Types.BoxType, 'top' | 'right' | 'bottom' | 'left'> => {
    const borderWidthOffset = borderWidth === 'sm' ? 1 : 2;
    const positionsMap = {
        'top-right': {
            top: offset - borderWidthOffset,
            right: offset - borderWidthOffset,
        },
        'top-left': {
            top: offset - borderWidthOffset,
            left: offset - borderWidthOffset,
        },
        'bottom-right': {
            bottom: offset - borderWidthOffset,
            right: offset - borderWidthOffset,
        },
        'bottom-left': {
            bottom: offset - borderWidthOffset,
            left: offset - borderWidthOffset,
        },
    };

    return positionsMap[position];
};

export const COLOR_BY_TYPE = {
    [TYPES.NEUTRAL]: 'grey_900',
    [TYPES.INFO]: 'blue_900',
    [TYPES.SUCCESS]: 'green_900',
    [TYPES.ERROR]: 'red_900',
    [TYPES.SPECIAL]: 'pink_900',
    [TYPES.WARNING]: 'yellow_900',
} as const;
